import { render, staticRenderFns } from "./TestimonialsCarousel.vue?vue&type=template&id=7ba2004e&scoped=true"
import script from "./TestimonialsCarousel.vue?vue&type=script&lang=js"
export * from "./TestimonialsCarousel.vue?vue&type=script&lang=js"
import style0 from "./TestimonialsCarousel.vue?vue&type=style&index=0&id=7ba2004e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba2004e",
  null
  
)

export default component.exports